<template>
    <div class="boxs">
      <div>
          <router-link tag="button" :to="{ path: '/Invoice' }">发货单</router-link>
      </div>
      <div>
        <router-link tag="button" :to="{ path: '/Sendcars' }">派车单</router-link>
      </div>
      <div>
          <router-link tag="button" :to="{ path: '/Login' }">登录</router-link>
      </div>
      <div>
          <router-link tag="button" :to="{ path: '/Register' }">注册</router-link>
      </div>
      <div>
          <router-link tag="button" :to="{ path: '/Credit' }">授信记录</router-link>
      </div>
      <div>
          <router-link tag="button" :to="{ path: '/CreditApply' }">授信申请</router-link>
      </div>

    </div>
</template>

<script>
export default {
    name: "home",
    data() {
        return {

        }
    },
    components: {
    },
    created() {
    },
    mounted() {
//        this.getUserData();
    },
    methods: {
        getUserData() {
            let data = {};
            this.$api.apis.getInfo(data).then(res => {
                console.log(res);
                localStorage.setItem("user", JSON.stringify(this.user));
            });
        }
    },
    destroyed() {
    }
};
</script>
<style scoped lang="less">
    .boxs{
        div{
            button{
                width: 100px;
                height: 100px;
                float: left;
                margin-right: 20px;
                margin-bottom: 20px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue